import React from 'react'
import { connect } from 'react-redux'
import { withRouteData } from 'react-static'

import { sortByKey, sortByKeys, track } from 'utils'

import {
    apidocsFromElasticAction,
    providersFromAPIAction,
} from '../connectors/redux/actions'

import Trackable from './Trackable'
import MetaTags from './MetaTags'
import DocLink from '../components/DocLink'
import HeroProvider from '../components/HeroProvider'
import ProviderAsAPICard from '../components/ProviderAsAPICard'
import ProviderCapabilities from '../components/ProviderCapabilities'
import { LegacyInfo } from '../components/LegacyInfo'

class Provider extends React.Component {
    async componentDidMount() {
        const {
            slug,
            dispatch,
            providersFromAPI,
            apidocsFromElastic,
        } = this.props

        const res = await apidocsFromElasticAction({ slug })(
            dispatch,
            apidocsFromElastic
        )

        if (providersFromAPI[slug]) {
            return
        }
        try {
            const { intents = [], instances = {} } =
                res.response.data.results || {}
            const providers = intents.map(intent => ({
                intent,
                id: instances[intent].id,
            }))
            await providersFromAPIAction({ providers, slug })(dispatch)
        } catch (e) {
            track('UI Error', { message: e, response: res })
        }
    }

    render() {
        const {
            slug,
            prefetchedIntents,
            prefetchedFirstIntent,
            prefetchedLogo,
            apidocsFromElastic,
        } = this.props

        const { results = {}, pending } = apidocsFromElastic[slug] || {}
        let { apidoc, intents = [] } = results

        if (!apidoc || !apidoc.name) {
            const {
                vendor = '',
                name = '',
                picture,
                logo,
                description = '',
            } = prefetchedFirstIntent
            apidoc = {
                vendor,
                name: name.replace(`${vendor} `, '') || description,
                version: '',
                description,
                links: [],
                image_url: picture,
                logo,
            }
            intents = prefetchedIntents.map(a => a.intent)
            // console.log(slug, apidoc, apidocsFromElastic[slug]);
        }
        const {
            vendor,
            name,
            version,
            description,
            links,
            image_url,
            logo,
            id,
        } = apidoc

        const title = `${vendor || ''} ${name} ${version}`
        const metatags = {
            title,
            description: title,
            og: {
                title,
                description: title,
                url: `https://inten.to/api-platform/api/${slug}`,
                image: prefetchedLogo,
                imageHeight: 200,
                imageWidth: 200,
            },
            twitter: {
                title,
                description: title,
                image: prefetchedLogo,
            },
        }

        const { related } = results

        const logoSrc = image_url
            ? `/${image_url}`
            : logo.replace('https://inten.to', '')

        let relatedAPIs = null

        if ((related || []).length > 1) {
            relatedAPIs = (
                <div className="doc__section animate-appear">
                    <div className="doc__title h2">Related APIs</div>
                    <div className="catalog__results">
                        <div className="api-cards">
                            <div className="api-cards__list">
                                {related
                                    .sort(sortByKey('vendor'))
                                    .map(provider => (
                                        <ProviderAsAPICard
                                            noModels
                                            key={provider.id}
                                            provider={{
                                                ...provider,
                                                api_id: provider.id,
                                                description: provider.name,
                                                picture: provider.image_url,
                                            }}
                                        />
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <Trackable page="provider">
                <MetaTags tags={metatags} />
                <HeroProvider apidoc={apidoc} intents={intents} />
                <section className="doc">
                    <div className="doc__container container">
                        <div className="doc__inner">
                            <div className="doc__section">
                                <LegacyInfo providerId={id} />
                                <div className="doc__desc">
                                    <div className="doc__desc-image">
                                        {logoSrc && (
                                            <img
                                                className="animate-appear"
                                                src={logoSrc}
                                                alt="Logo"
                                            />
                                        )}
                                    </div>
                                    <div className="doc__desc-content">
                                        {pending && !description && (
                                            <p style={{ opacity: 0.5 }}>
                                                Loading...
                                            </p>
                                        )}
                                        {(description || !pending) && (
                                            <p className="animate-appear">
                                                {description || ''}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <ProviderCapabilities />

                            {(links || []).length > 1 && (
                                <div className="doc__section animate-appear">
                                    <div className="doc__title h2">Links</div>
                                    <div className="doc__links">
                                        <ul className="resource-links">
                                            {links
                                                .sort(
                                                    sortByKeys('type', 'title')
                                                )
                                                .map(link => (
                                                    <DocLink
                                                        key={link.id}
                                                        {...link}
                                                    />
                                                ))}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {relatedAPIs}
                        </div>
                    </div>
                </section>
            </Trackable>
        )
    }
}

function mapStateToProps(state) {
    return {
        apidocsFromElastic: state.apidocsFromElastic || {},
        providersFromAPI: state.providersFromAPI || {},
    }
}

export default connect(mapStateToProps)(withRouteData(Provider))



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/containers/Provider.jsx